module.exports = __webpack_public_path__ + "static/img/business44.38d904c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/business/business44.jpg
// module id = AtcG
// module chunks = 9